/**
 * Store permettant de gérer les filtres d'affichange dans les différents menus
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ingouvernance: {
    all: false,
    espace: false,
    partieprenante: false,
    rituel: true,
    role: false,
    tempscollectif: false,
  },
  insocial: {
    all: false,
    acteur: true,
    evenement: false,
  },
  inoperation: {
    all: false,
    viemissions: false,
    rdvmissions: true,
    engagements: false,
  },
  inviews: {
    all: false,
    idee: false,
    actualite: false,
    emission: true,
    podcast: false,
    publication: false,
  },
  utiliser: {
    all: false,
    espace: true,
    mobilite: false,
  },
};

export const ReduxFilterSlice = createSlice({
  name: "ReduxFilter",
  initialState,
  reducers: {
    chgEspaceFilter: (state, action) => {
      state.ingouvernance.espace = action.payload;
      state.ingouvernance.partieprenante = false;
      state.ingouvernance.rituel = false;
      state.ingouvernance.role = false;
      state.ingouvernance.tempscollectif = false;

      if (action.payload === true) state.ingouvernance.all = false;
      else state.ingouvernance.all = true;
    },
    chgRituelFilter: (state, action) => {
      state.ingouvernance.espace = false;
      state.ingouvernance.partieprenante = false;
      state.ingouvernance.rituel = action.payload;
      state.ingouvernance.role = false;
      state.ingouvernance.tempscollectif = false;

      if (action.payload === true) state.ingouvernance.all = false;
      else state.ingouvernance.all = true;
    },
    chgPartieprenanteFilter: (state, action) => {
      state.ingouvernance.espace = false;
      state.ingouvernance.partieprenante = action.payload;
      state.ingouvernance.rituel = false;
      state.ingouvernance.role = false;
      state.ingouvernance.tempscollectif = false;

      if (action.payload === true) state.ingouvernance.all = false;
      else state.ingouvernance.all = true;
    },
    chgRoleFilter: (state, action) => {
      state.ingouvernance.espace = false;
      state.ingouvernance.partieprenante = false;
      state.ingouvernance.rituel = false;
      state.ingouvernance.role = action.payload;
      state.ingouvernance.tempscollectif = false;

      if (action.payload === true) state.ingouvernance.all = false;
      else state.ingouvernance.all = true;
    },
    chgTempscollectifFilter: (state, action) => {
      state.ingouvernance.espace = false;
      state.ingouvernance.partieprenante = false;
      state.ingouvernance.rituel = false;
      state.ingouvernance.role = false;
      state.ingouvernance.tempscollectif = action.payload;

      if (action.payload === true) state.ingouvernance.all = false;
      else state.ingouvernance.all = true;
    },
    chgActeurFilter: (state, action) => {
      state.insocial.acteur = action.payload;
      state.insocial.evenement = false;

      if (action.payload === true) state.insocial.all = false;
      else state.insocial.all = true;
    },
    chgEvenementFilter: (state, action) => {
      state.insocial.acteur = false;
      state.insocial.evenement = action.payload;

      if (action.payload === true) state.insocial.all = false;
      else state.insocial.all = true;
    },
    chgVieMissionsFilter: (state, action) => {
      state.inoperation.viemissions = action.payload;
      state.inoperation.rdvmissions = false;
      state.inoperation.engagements = false;

      if (action.payload === true) state.inoperation.all = false;
      else state.inoperation.all = true;
    },
    chgRdvMissionsFilter: (state, action) => {
      state.inoperation.viemissions = false;
      state.inoperation.rdvmissions = action.payload;
      state.inoperation.engagements = false;

      if (action.payload === true) state.inoperation.all = false;
      else state.inoperation.all = true;
    },
    chgEngagementsFilter: (state, action) => {
      state.inoperation.viemissions = false;
      state.inoperation.rdvmissions = false;
      state.inoperation.engagements = action.payload;

      if (action.payload === true) state.inoperation.all = false;
      else state.inoperation.all = true;
    },
    chgIdeeFilter: (state, action) => {
      state.inviews.idee = action.payload;
      state.inviews.actualite = false;
      state.inviews.emission = false;
      state.inviews.podcast = false;
      state.inviews.publication = false;

      if (action.payload === true) state.inviews.all = false;
      else state.inviews.all = true;
    },
    chgActualiteFilter: (state, action) => {
      state.inviews.idee = false;
      state.inviews.actualite = action.payload;
      state.inviews.emission = false;
      state.inviews.podcast = false;
      state.inviews.publication = false;

      if (action.payload === true) state.inviews.all = false;
      else state.inviews.all = true;
    },
    chgEmissionFilter: (state, action) => {
      state.inviews.idee = false;
      state.inviews.actualite = false;
      state.inviews.emission = action.payload;
      state.inviews.podcast = false;
      state.inviews.publication = false;

      if (action.payload === true) state.inviews.all = false;
      else state.inviews.all = true;
    },
    chgPodcastFilter: (state, action) => {
      state.inviews.idee = false;
      state.inviews.actualite = false;
      state.inviews.emission = false;
      state.inviews.podcast = action.payload;
      state.inviews.publication = false;

      if (action.payload === true) state.inviews.all = false;
      else state.inviews.all = true;
    },
    chgPublicationFilter: (state, action) => {
      state.inviews.idee = false;
      state.inviews.actualite = false;
      state.inviews.emission = false;
      state.inviews.podcast = false;
      state.inviews.publication = action.payload;

      if (action.payload === true) state.inviews.all = false;
      else state.inviews.all = true;
    },

    chgUtiliserEspacesFilter: (state, action) => {
      state.utiliser.espace = action.payload;
      state.utiliser.mobilite = false;

      if (action.payload === true) state.utiliser.all = false;
      else state.utiliser.all = true;
    },
    chgUtiliserMobilitesFilter: (state, action) => {
      state.utiliser.espace = false;
      state.utiliser.mobilite = action.payload;

      if (action.payload === true) state.utiliser.all = false;
      else state.utiliser.all = true;
    },
  },
});

export const {
  chgEspaceFilter,
  chgRituelFilter,
  chgPartieprenanteFilter,
  chgRoleFilter,
  chgTempscollectifFilter,
  chgActeurFilter,
  chgEvenementFilter,
  chgVieMissionsFilter,
  chgRdvMissionsFilter,
  chgEngagementsFilter,
  chgIdeeFilter,
  chgActualiteFilter,
  chgEmissionFilter,
  chgPublicationFilter,
  chgPodcastFilter,
  chgUtiliserEspacesFilter,
  chgUtiliserMobilitesFilter,
} = ReduxFilterSlice.actions;

export const selectInGouvernanceFilters = (state) => state.ReduxFilter.ingouvernance;
export const selectInSocialFilters = (state) => state.ReduxFilter.insocial;
export const selectInOperationFilters = (state) => state.ReduxFilter.inoperation;
export const selectInViewsFilters = (state) => state.ReduxFilter.inviews;
export const selectUtiliserFilters = (state) => state.ReduxFilter.utiliser;

export default ReduxFilterSlice.reducer;
